import { z } from "zod";

// Selection metadata for history items
export const selectionMetaDataSchema = z.object({
	totalAvailablePackagingSolutions: z.number().optional(),
	configuredPipelineSteps: z.array(z.string()),
	cartonsBeforeFilters: z.record(z.string(), z.number()),
	cartonsAfterFilters: z.record(z.string(), z.number()),
	filterToRemoveRemaining: z.string().optional(),
	pipelineName: z.string().optional(),
});
export type SelectionMetaData = z.infer<typeof selectionMetaDataSchema>;

// Individual selection history item
export const selectionHistoryItemSchema = z.object({
	id: z.string(),
	auditType: z.string(),
	alias: z.string(),
	createDateUTC: z.string(),
	selectionMetaData: selectionMetaDataSchema.optional(),
});
export type SelectionHistoryItem = z.infer<typeof selectionHistoryItemSchema>;

// Machine group selection history
export const machineGroupSelectionHistorySchema = z.object({
	machineGroupId: z.string(),
	machineGroupAlias: z.string(),
	selectionHistory: z.array(selectionHistoryItemSchema),
});
export type MachineGroupSelectionHistory = z.infer<typeof machineGroupSelectionHistorySchema>;

// Oldest item data for selection analytics
export const oldestItemDataSchema = z.object({
	alias: z.string(),
	id: z.string(),
	recordCreatedDate: z.string(),
});
export type OldestItemData = z.infer<typeof oldestItemDataSchema>;

// Production group reference for selection analytics
export const selectionAnalyticsProductionGroupSchema = z.object({
	id: z.string(),
	alias: z.string(),
});
export type SelectionAnalyticsProductionGroup = z.infer<typeof selectionAnalyticsProductionGroupSchema>;

// Selection analytics data per production group
export const selectionAnalyticsDataSchema = z.object({
	pg: selectionAnalyticsProductionGroupSchema,
	count: z.number(),
	oldest: oldestItemDataSchema.optional(),
	averageLingerTime: z.string().optional(),
});
export type SelectionAnalyticsData = z.infer<typeof selectionAnalyticsDataSchema>;

// Selection audit stat for a production group
export const selectionAuditStatSchema = z.object({
	productionGroupId: z.string(),
	averageTimeToSelect: z.number(),
	averageTotalAvailablePackagingSolutions: z.number(),
});
export type SelectionAuditStat = z.infer<typeof selectionAuditStatSchema>;

// Selection audit response from analytics endpoint
export const selectionAuditResponseSchema = z.object({
	selectionHistoryForProductionGroups: z.array(selectionAuditStatSchema),
});
export type SelectionAuditResponse = z.infer<typeof selectionAuditResponseSchema>;
